import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'themeColorSelector'
})
export class ThemeColorSelectorPipe implements PipeTransform {

  transform(theme: any): any {
    let color = '';
    if(theme === 'light')
      color = '#9aa7b5';
    else if(theme === 'dark')
      color = '#565a71';
    return color;
  }

}
